export const getUniqueReferenceId = (partnerId) => {
   let uuid = new Date().getTime();
   return 'VA' + (uuid + partnerId);
};

export const encodeBase64 = (inputCharacter) => {
   return window.btoa(inputCharacter);
};
